/**
 * Set of registered page transition listeners.
 */
const listeners = new Set();

/**
 * Subscribe to page transition events.
 * Registers a listener function that will be called when a page transition is requested.
 *
 * @param {Function} listener - The callback function to execute on page transition
 * @returns {Function} Unsubscribe function that removes the listener when called
 */
export const subscribePageTransition = (listener) => {
  if (typeof listener !== "function") return () => {};
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * Request a page transition.
 * Triggers all registered page transition listeners.
 * Any errors thrown by individual listeners are caught and logged.
 *
 * @returns {void}
 */
export const requestPageTransition = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error("[PageTransition] listener error", error);
    }
  });
};
